import { BASE } from './index';
import axios from './http';

const message = {
    //未读消息列表
    msglist: params => axios.post(`${BASE.PRO}/api/msg/list`,  params ),
};

export default message;
